module.exports = __webpack_public_path__ + "img/face1@2x.830e6532.png";